module.exports = __webpack_public_path__ + "img/xiguang1.b8a2eb2a.png";